import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BiShowAlt } from "react-icons/bi";
import _objI from "@/utils/_objI";
import Image from "next/image";
import Edit from "assets/svg/tableEdit.svg";
import Delete from "assets/svg/tableDelete.svg";
import Show from "assets/img/Show.png";

type optionList = {
  title: string;
  event: any;
};
type TableAction = {
  title: string;
  action?: any;
  active?: boolean;
  onClick?: (row: any) => any;
  icon?: JSX.Element;
};
type PropsType = {
  list?: optionList[];
  parentStyles?: string;
  popUpStyles?: string;
  optionStyle?: string;
  icon?: React.FC;
  image?: string;
  index?: number;
  row: any;
  tableAction?: TableAction[];
};
const ActionDropDown: React.FC<PropsType> = ({ row, tableAction }) => {
  const { t, i18n } = useTranslation();
  const actionObject = {
    view: {
      icon(onClick, row) {
        return (
          <Image
            onClick={async () => {
              if (onClick && typeof onClick === "function") {
                await onClick(row);
              }
            }}
            src={Show}
            alt="img"
          />
        );
      },
    },
    edit: {
      icon(onClick, row) {
        return (
          <Image
            alt="img"
            src={Edit}
            onClick={async () => {
              if (onClick && typeof onClick === "function") {
                await onClick(row);
              }
            }}
          />
        );
      },
    },
    delete: {
      icon(onClick, row) {
        return (
          <Image
            alt="img"
            src={Delete}
            onClick={async () => {
              if (onClick && typeof onClick === "function") {
                await onClick(row);
              }
            }}
          />
        );
      },
    },
  };
  return (
    <div className="relative flex items-center justify-start min-w-[83px] gap-3 select-none ">
      {tableAction.map((item, index) => {
        if (["view", "edit", "delete"].includes(item.title)) {
          return (
            <div
              className="relative flex flex-col items-center justify-center w-auto transition-transform duration-200 transform cursor-pointer hover:scale-110 group "
              key={index}
              title={t(item.title)}
            >
              {actionObject[item.title].icon(item?.action, row)}
            </div>
          );
        } else {
          return (
            <div
              className="relative flex flex-col items-center justify-center w-auto transition-transform duration-100 transform cursor-pointer hover:scale-90 group "
              key={index}
              title={t(item.title)}
            >
              {item.action(row)}
            </div>
          );
        }
      })}
    </div>
  );
};
export default ActionDropDown;
